import React from 'react'
import { useSelector } from 'react-redux'
import { checkPermission } from 'constants/permissions'

/**
 * Permission-based Render Component
 * Professional way to conditionally render content based on user permissions
 *
 * Usage:
 *   <Can do={PERMISSIONS.WORKORDER.DELETE}>
 *     <button className="btn-danger">Delete Order</button>
 *   </Can>
 *
 * With fallback content:
 *   <Can do={PERMISSIONS.WORKORDER.DELETE} fallback={<span>No permission</span>}>
 *     <button className="btn-danger">Delete Order</button>
 *   </Can>
 *
 * @param {string} do - Permission slug to check (e.g., PERMISSIONS.CONTRACT.EDIT)
 * @param {ReactNode} children - Content to show if user has permission
 * @param {ReactNode} fallback - Optional content to show if user doesn't have permission
 */
const Can = ({ do: permissionSlug, children, fallback = null }) => {
  // Get permission status from Redux state using the selector
  const isAllowed = useSelector(checkPermission(permissionSlug))

  // Render children if allowed, otherwise render fallback
  return isAllowed ? <>{children}</> : fallback
}

export default Can
